import React from "react";
import styles from "./code.module.scss";
import HTML from "dangerously-set-html-content";

const Code = ({ code }) => {
  return <HTML className={styles.element} html={code} />;
};

export default Code;
